import { withAsyncLoading } from "../../Components/Templates/Loading/AsyncPageLoading";

export const QuotePageLoading = withAsyncLoading(async () =>
  import("./QuotePage").then((res) => res.QuotePage)
);

